import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 12 20" {...props}><path className={styles["st0"] || "st0"} d="M3.5 10l8.4-8.3L10.2 0 .1 10l10.1 10 1.7-1.7z" /></svg>);